<div class="tabs tabBlue">
  <span class="tablinks all_stories " (click)="openActivePage(0, 'microsite')"
    [class]="activeMenu === 'micrositeInfo' ? 'active' : ' '" id="defaultOpen">Microsite Info</span>
    <ng-container *ngIf="micrositeData && micrositeData.pageIds.length > 0">
      <ng-container *ngFor="let page of micrositeData.pageIds, let i=index">
        <span id='templateTab' class="tablinks my_workspace" (click)="openActivePage(i, 'pages')"
        [class]="(activeMenu === 'pageList' && activePage === i )? 'active' : ' '" id="printFeedTab">Page {{i+1}}</span>
      </ng-container>
    </ng-container>
  
  
</div>

<ng-container *ngIf="micrositeData">
  <div class="pageContainer tabcontent" id="allStories" style="display:block;">
    <div class="tabs minSpace">
      <!-- <span class="tablinks bold cursor_auto" onclick="opentab(event, 'allStories')"
        id="defaultOpen">{{micrositeData?.name}}</span> -->
        <span>Microsite Name - {{micrositeData.name}}</span>
      <button type="button" name="createCard" *ngIf="!pageEditMode && !(accessType=='View')" (click)="unlockPage()" class="blue  m0c">
        Unlock page
      </button>

      <div class="secondaryCta fr" *ngIf="this.micrositeData?.status === 'PUBLISHED'" #secondaryCTAs>
        <span class="threedots" (click)="revertListFlag = !revertListFlag">
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div class="revertStoryBlock" *ngIf="revertListFlag">
          <ul>

            <li>
              <button (click)="purgePage()">
                Purge Page
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tabcontainer pageEditor spacing" *ngIf="activeMenu !== 'micrositeInfo' && (micrositeData.design !== 'template')">
      <div class="">
        <div class="allContent">

          <h4>All Content</h4>
          <div class="blockContain">
            <div class="custom-select" *ngIf="(micrositeData.design !== 'list' || isCardViewEnabled('elements') || !sharedService.isdomainConfig('pages','showDomainFilter'))">
              <select [(ngModel)]="Category" class="fr" id="category">
                <option value="story" selected>story</option>
                <option value="elements">elements</option>
              </select>
            </div>
            <div *ngIf="Category == 'story'" class="app-page-listing" isPage="story" [pageManager]="true"
              pageId="all_stories" allApi="all_story" showSearch="true" [mergeArticles]="mergeArray" getDragulaId="left"
              searchApi="search_story" metaApi="dashboard_meta" pageArticleApi="page_putArticle">
            </div>
            <div *ngIf="Category == 'elements'" class="app-page-listing" isPage="elements" [pageManager]="true"
              [mergeArticles]="mergeArray" pageId="element" allApi="all_elements" showSearch="true" getDragulaId="left"
              searchApi="search_elements" metaApi="element_meta" pageArticleApi="page_putArticle">

            </div>
            <div class="lockbg" *ngIf="!pageEditMode"></div>
          </div>
        </div>
        <div class="livePage">
          <h4>Line-up</h4><i class="clearLineUp icon-clear_chache" (click)="openLineupPopup()"
            title="Clear Line-up"></i>
          <div class="blockContain">
            <ng-container *ngIf="pageData">
              <div #lineupElement class="app-page-listing" pageId="pages" allApi="page_list" isPage="elements"
              showSearch="false" getDragulaId="right" [showPageId]="pageData.id" [pagePinIds]="pushPinnedArticles" [dummy]="dummy"
              (sendListIdToParentfn)="getListIdToParentfn($event)"
              (sendPageArticleIdToParentfn)="getArticleIdToParentfn($event)" pageArticleApi="page_putArticle">
            </div>
            </ng-container>
            
            <div class="lockbg" *ngIf="!pageEditMode"></div>
            <div class="lockbg" *ngIf="showlockBg" (click)="showlockBg = false"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="tabcontainer marb20" *ngIf="activeMenu === 'micrositeInfo'">
      <div>Microsite Name - <span>{{micrositeData.name}}</span> </div> 
      <div>Page URL - <span>{{micrositeData.pageUrls[0]}}</span> </div> 
      <div>Description - <span>{{micrositeData.description}}</span> </div> 
      <div>Number of Pages - <span>{{micrositeData.pageCount}}</span> </div> 
      <div>Status - <span>Published</span> </div> 
    </div> -->
    <div class="clearBoth"></div>
  </div>
  <div class="thirdContainScroll">
    <div class="thirdContainer">
      <div *ngIf="activeMenu === 'micrositeInfo' && micrositeData" class="usermeta blocks marb20">
        <div class="head">Metadata</div>
        <div class="form">
          <ul>
            <li>
              <label>Microsite Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode"
                  id="{{micrositeData.name}}" [(ngModel)]="micrositeData.name" placeholder="Add page name here…">
              </div>
            </li>

            
            <li>
              <label>Description</label>
              <div class="dataField">
                <textarea class="textBox" [readOnly]="!pageEditMode" id="{{micrositeData.description}}"
                  [(ngModel)]="micrositeData.description" placeholder="Add description here…"></textarea>
              </div>
            </li>
            
            <li>
              <label>Logo Image</label>
              <div class="dataField">
                <div class="uploadimage" *ngIf="!micrositeData.logo"><i class="icon-upload"></i>
                  <div class="dataField">
                    <div class="stepsDropBlock">
                      <div class="imageInsert uploadnew">
                        <!-- <span>Upload from file</span> -->
                        <label for="uploadfile" class="new">Upload from file</label>
                        <input id="uploadfile" type="file" hidden name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'logo')" />
                       
                      </div>
                      <div class="imageLibrary " (click)="addLogoGallery()">
                        <label class="new">Pick from Library</label>
                      </div>
                      </div>
                  </div>
                </div>
                <!-- <span *ngIf="micrositeData.logo" class="deleteImage" (click)="deleteImage('cover')"><i class="icon-delete"></i></span> -->
                <div class="cover-image cover_width">
                  <ng-container  *ngIf="micrositeData.logo && !pickStoryImageLoad && !croppingInProgress">
                    <img src="{{micrositeData.logo}}" width="173"
                      height="76" />
                  </ng-container>
                  <!-- <ng-container  *ngIf="!micrositeData.logo">
                    <img src="{{micrositeData.logo}}" width="173"
                      height="76" />
                  </ng-container> -->
                  </div>
                  <span *ngIf="micrositeData.logo" class="deleteImage" (click)="deleteImage('msLogo')"><i class="icon-delete"></i></span>
           
              </div>
            </li>
            <li>
              <label>Banner Image</label>
              <div class="dataField">
                <div class="uploadimage" *ngIf="!micrositeData.banner"><i class="icon-upload"></i>
                  <div class="dataField">
                    <div class="stepsDropBlock">
                      <div class="imageInsert uploadnew">
                        <!-- <span>Upload from file</span> -->
                        <label for="uploadfile" class="new">Upload from file</label>
                        <input id="uploadfile" type="file" hidden name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'banner')" />
                       
                      </div>
                      <div class="imageLibrary " (click)="addBannerGallery()">
                        <label class="new">Pick from Library</label>
                      </div>
                      </div>
                  </div>
                </div>
                <!-- <span *ngIf="micrositeData.banner" class="deleteImage" (click)="deleteImage('cover')"><i class="icon-delete"></i></span> -->
                <div class="cover-image cover_width">
                  <ng-container  *ngIf="micrositeData.banner && !pickStoryImageLoad && !croppingInProgress">
                    <img src="{{micrositeData.banner}}" width="173"
                      height="76" />
                  </ng-container>
                </div>
                <span *ngIf="micrositeData.banner" class="deleteImage " (click)="deleteImage('msBanner')"><i class="icon-delete"></i></span>
           
              </div>
            </li>
              
           

          </ul>
        </div>
      </div>
      <div *ngIf="activeMenu !== 'micrositeInfo' && pageData" class="usermeta blocks marb20">
        <div class="head">Metadata</div>
        <div class="form">
            <ul class="bylineBlock">
                <li *ngIf="disabledMetaFields.indexOf('byline') === -1">
                  <label>By Line</label>
                  <div class="dataField">
                    <tags-creator [autoSuggest]="true" [autocompletelist]="authorsSuggestion" (focusoutfn)="disableInnerFocus($event)"
                      [editable]="!pageEditMode" [data]="pageData.metadata.authors" [setFocus]="innerFocusFlag"
                      [displayText]="'Add Byline here..'" (clickfn)="customFunc($event)" (changefn)="pageData.metadata.authors = $event"
                      (focusedfn)="catchTagFocus($event)"></tags-creator>
                  </div>
                </li>
                <ng-container *ngFor="let field of fieldSet">
                  <ng-container *ngIf="disabledMetaFields.indexOf(field.metadataModelId) === -1">
                  <li *ngIf="disableElement('meta-more') ? pageData.metadata[field.metadataModelId] ? pageData.metadata[field.metadataModelId].length > 0 : false : true">
                    <ng-container *ngIf="!field.auto">
                      <label>{{field.labelName}}</label>

                      <div class="dataField">
                        <ul id="myAuthors">
                          <tags-creator [data]="pageData.metadata.agencyByLine" [editable]="!pageEditMode" [displayText]="'Agency Byline'"
                            (clickfn)="customFunc($event)" (changefn)="pageData.metadata.agencyByLine = $event"
                            (focusedfn)="catchTagFocus($event)"></tags-creator>
                        </ul>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="field.auto">
                      <label>{{field.labelName}}</label>
                      <div class="dataField">
                        <ul id="myAuthors">
                          <tags-creator [autoSuggest]="true" [autocompletelist]="authorsSuggestion" [setFocus]="field.focusFlag"
                            [editable]="!pageEditMode" [data]="getValuefromThis(field.dataModelId)" [displayText]="field.inputPlaceholder"
                            (clickfn)="customFunc($event)" (changefn)="pageData.metadata[field.metadataModelId] = $event"
                            (focusedfn)="catchTagFocus($event)"></tags-creator>
                        </ul>
                      </div>
                    </ng-container>
                  </li>
                </ng-container>
                </ng-container>
                <ng-container *ngIf="disabledMetaFields.indexOf('column') === -1">
                <li >
                  <label>Column</label>
                  <div class="dataField">
                    <input type="text" [class]="'textBox'" #columnInput [readonly]="!pageEditMode" placeholder="Add Column here."
                      [(ngModel)]="columnQuery" (keyup)="filterAutoCompleteUp($event ,'column')" (keydown)="filterAutoCompleteDown($event ,'column')"
                      (focus)="focusInSuggest('column')" (focusout)="false">
                    <ng-container *ngIf="pageEditMode">
                      <div #columnList class="autosuggestion block" *ngIf="filteredColumnSuggestion && filteredColumnSuggestion.length > 0">
                        <ul *ngFor="let item of filteredColumnSuggestion; let i = index">
                          <li (click)="selectAutoComplete('column', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideColumn && (1 > filteredColumnSuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li>
                              <span class="name">No Results</span>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </li>
                </ng-container>
                <ng-container *ngIf="isMoreButtonEnabled">
                <li>
                  <span [class]="(disableElement('meta-more') ? 'more' : 'less') + ' spImg_story'" (click)="metaToggleFlag = !metaToggleFlag">
                    {{disableElement('meta-more') ? 'more' : 'less'}}
                  </span>
                </li>
              </ng-container>
              </ul>
          <ul>
            <li>
              <label>Name</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode"
                  id="{{pageData.name}}" [(ngModel)]="pageData.name" placeholder="Add page name here…">
              </div>
            </li>

            
            <li>
              <label>Title</label>
              <div class="dataField">
                <input type="text" class="textBox" [readOnly]="!pageEditMode" id="{{pageData.title}}"
                  [(ngModel)]="pageData.title" placeholder="Add meta title here…">
              </div>
            </li>
            <li>
              <label>Keywords</label>
              <div class="dataField">
                <ul id="myKeyword" class="tagit">
                  <li class="tagit-new">
                    <tags-creator [data]="pageData.keywords" [editable]="!pageEditMode"
                      [displayText]="'Add keywords here..'" (changefn)="pageData.keywords = $event"></tags-creator>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <label>
                Section
              </label>
              <div id="inputAddSectionText" class="dataField">
                <input type="text" class="textBox" #sectionInput [readonly]="!pageEditMode" placeholder="Add Section here."
                  [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteUp($event ,'section')" (keydown)="filterAutoCompleteDown($event ,'section')"
                  (focus)="focusInSuggest('section')" (focusout)="false">
                <ng-container *ngIf="pageEditMode">
                  <div #sectionList class="autosuggestion block" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && insideSection">
                    <ul *ngFor="let item of filteredSectionSuggestion;let i = index">
                      <li (click)="selectAutoComplete('section', item)" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="insideSection && (!filteredSectionSuggestion || 1 > filteredSectionSuggestion.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </ng-container>

              </div>
            </li>
            <li>
              <label>Sub-section
              </label>

              <div id="inputAddSubSectionText" class="dataField">
                <input type="text" class="textBox" #subSectionInput [readonly]="!pageEditMode"
                  placeholder="Add SubSection here." [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteUp($event ,'subSection')"
                  (keydown)="filterAutoCompleteDown($event ,'subSection')" (focus)="focusInSuggest('subSection')"
                  (focusout)="false">
                <ng-container *ngIf="pageEditMode">
                  <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                    <ul *ngFor="let item of filteredSubSectionSuggestion; let i = index">
                      <li (click)="selectAutoComplete('subSection', item)" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="insideSubSection && (!filteredSubSectionSuggestion || 1 > filteredSubSectionSuggestion.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>

                      </ul>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </li>
            <li>
              <label>Description</label>
              <div class="dataField" #descEl>
                <ng-container *ngIf="!sharedService.isdomainConfig('story','newsletter-fields')">
                <textarea type="text" class="textBox" id="{{pageData.description}}" [readOnly]="!pageEditMode"
                [(ngModel)]="pageData.description" placeholder="Add description here…"></textarea>
              </ng-container>
                <ng-container *ngIf="sharedService.isdomainConfig('story','newsletter-fields')">
                <ckeditor [(ngModel)]="pageData.description" [editor]="ckEditor"
                [disabled]="(!pageEditMode)" [config]="ckconfig" [tabindex]="0" (ready)="ckchanges($event, 'ready', 'desc')"
                  (change)="ckchanges($event, 'change', 'desc')" (blur)="ckchanges($event, 'blur', 'desc')"
                  (focus)="ckchanges($event, 'focus', 'desc')" (error)="ckchanges($event, 'error', 'desc')"></ckeditor>
                </ng-container>
              </div>
            </li>
            <li>
              <label>Auto-Backlinking Enabled</label>
               <div class="dataField">
              <label class="switch" tabindex="0">
                <input
                  type="checkbox"
                  (click)="toggleSwitch('autobacklink')"
                  [checked]="pageData.toBeAutobacklink"/>
                <span class="slider round"></span>
              </label>
            </div>
            </li>
            <li *ngIf="sharedService.isdomainConfig('story','newsletter-fields')">
              <label>Additional Info</label>
              <div class="dataField" #infoEl>
                <ckeditor [(ngModel)]="pageData.additionalInfo" [editor]="ckEditor2"
                [disabled]="(!pageEditMode)" [config]="ckconfig" [tabindex]="0" [config]="ckconfig" [tabindex]="0" (ready)="ckchanges($event, 'ready', 'info')"
                  (change)="ckchanges($event, 'change', 'info')" (blur)="ckchanges($event, 'blur', 'info')"
                  (focus)="ckchanges($event, 'focus', 'info')" (error)="ckchanges($event, 'error', 'info')"></ckeditor>
              </div>
            </li>
            
           
            <li *ngIf="sharedService.isdomainConfig('pages','revenueSpecial')">
            <label>Revenue Specials</label>
            <div class="dataField">
              <label class="switch" tabindex="0">
                <input
                  type="checkbox"
                  (click)="toggleSwitch('revenueSpecial')"
                  [checked]="pageData.metadata.revenueSpecial"/>
                <span class="slider round"></span>
              </label>
            </div>
            </li>
            <li>
              <label>Cover Image</label>
              <div class="dataField">
                <div class="uploadimage" *ngIf="pageEditMode"><i class="icon-upload"></i>
                  <div class="upload-btn-wrapper relative">
                    <span class="btn">Upload Image</span>
                    <input type="file" name="myfile" (change)="onFileChange($event,'coverImage')" />
                  </div>
                </div>
                <span *ngIf="pageData.coverImage && !pickStoryImageLoad && !croppingInProgress" class="deleteImage" (click)="deleteImage('cover')"><i class="icon-delete"></i></span>
                <div class="cover-image">
                  <ng-container *ngIf="(pickStoryImageLoad || croppingInProgress) && imageType === 'coverImage' ">
                    <div class="imagepreloader">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container  *ngIf="pageData.coverImage && !pickStoryImageLoad && !croppingInProgress">
                    <img src="{{pageData.coverImage}}" width="173"
                      height="76" />
                  </ng-container>
                  </div>
              </div>
            </li>
              <ng-container *ngIf="pageData.coverImage && !pickStoryImageLoad && !croppingInProgress">
                <li>
                  <label>Image Caption</label>
                  <div class="dataField">
                    <input type="text" class="textBox" [readOnly]="!pageEditMode" id="{{pageData.imageCaption}}"
                      [(ngModel)]="pageData.imageCaption" placeholder="Add image Caption here…">
                  </div>
                </li>
              </ng-container>
              <li>
            </li>

          </ul>
        </div>
      </div>
      <div class="systemmeta blocks marb20">
        <div class="head">Page Info</div>
        <div class="form">
          <ul *ngIf="activeMenu !== 'micrositeInfo' && pageData">
            <li>
              <label>Status</label>
              <div class="dataField"><span class="link">{{micrositeData.status ? micrositeData.status : 'CREATED' }}</span></div>
            </li>
            <li>
              <label>URL</label>
              <div class="dataField"><span class="link">{{pageData.url}}</span></div>
            </li>
            <li>
              <label>Format</label>
              <div class="dataField"><span class="">{{pageData.pageType}}</span></div>
            </li>
          </ul>
          <ul *ngIf="activeMenu === 'micrositeInfo'">
            <li>
              <label>Status</label>
              <div class="dataField"><span class="link">{{micrositeData.status ? micrositeData.status : 'CREATED' }}</span></div>
            </li>
            <li>
              <label>Microsite Name</label>
              <div class="dataField"><span class="link">{{micrositeData.name}}</span></div>
            </li>
            <li>
              <label>URL</label>
              <div class="dataField"><span class="link">{{micrositeData.url}}</span></div>
            </li>
            <li>
              <label>Number of Pages</label>
              <div class="dataField"><span class="link">{{micrositeData.pageCount}}</span></div>
            </li>
            
            

          </ul>
        </div>
      </div>
      <div *ngIf="activeMenu !== 'micrositeInfo'" class="storytime blocks">
        <div class="head">Page Timeline</div>
        <div class="form">

          <div class="tiimeline">
            <ng-container *ngFor="let item of listOfHistoryArray;let i = index">
              <div class="block" *ngIf="i < 5">
                <div class="updateby">
                  <p>Date</p>
                  <div class="author">{{item.name}} </div>
                </div>
                <div class="time">{{getVersionDate(+item.historyDate)}}</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="image-cropper" *ngIf="showCropper && imageType === 'coverImage'" [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event,imageType)"
    (cancel)="cancelCropping($event)"></div>

  <div class="image-cropper" *ngIf="showCropper && imageType ==='sponsorImage' " [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event,imageType)"
    (cancel)="cancelCropping($event)"></div>


  <div class="lightBox readstory clearLineUpBlock block" *ngIf="deleteLineupPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Clean Line-up</h3>
        <p>Do you want to clear all stories in Line-up? This action cannot be reversed</p>
      </div>
      <div class="fr wid100 right ptb15">
        <button type="button" name="cancel" (click)="closeLineupPopup()" class="cancel gray">Cancel</button>
        <button type="button" name="unlock" (click)="clearPageLineup()" class="add blue">Confirm</button>
      </div>
    </div>
  </div>

  <div class="viewPreview lightBox block" *ngIf="previewPopup">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
    </div>
    <ng-container *ngIf="previewUrl !== null">
      <div [class]="((previewPlatform === 'mobile') ? 'previewContainer mobile' : 'previewContainer desktop')">
        <div class="loaderimage loaderimagepreview block">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </div>
        <iframe appIframeTracker [src]="previewUrl" [style]="iframeStyle" (load)="iframeLoaded($event)"></iframe>
      </div>
    </ng-container>
  </div>

</ng-container>
<ng-container *ngIf="!micrositeData">
  <div class="imagepreloader">
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</ng-container>

<div [class]="bannerGalleryFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="bannerGalleryFlag = false;"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addLogo($event, 'banner')" *ngIf="bannerGalleryFlag"></div>
</div>

<div [class]="logoGalleryFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="logoGalleryFlag = false;"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addLogo($event, 'logo')" *ngIf="logoGalleryFlag"></div>
</div>

<div class="image-cropper" *ngIf="showLogoCropper" [cropperImageUrl]="cropperImageUrl" 
  (finish)="finishCropping($event, 'logo')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isMicrositeImage]="true" 
  ></div>

<div class="image-cropper" *ngIf="showBannerCropper" [cropperImageUrl]="cropperImageUrl" 
(finish)="finishCropping($event, 'banner')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [liveblogCropper]="true" 
></div>
